export default function LocalIntro() {
  return (
    <section className="bg-white py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-semibold text-[#1E3A47]">
            Votre réparateur de fenêtre à Erstein
          </h2>
        </div>
        <div className="space-y-6 text-sm md:text-base text-[#243038] leading-relaxed">
          <p>
              Erstein, au sud de Strasbourg, connaît une expansion résidentielle rapide. Entre les lotissements neufs et le centre historique alsacien, les fenêtres courent du PVC moderne au bois traditionnel. Nos techniciens réparent le mécanisme chez vous, pièce comprise, déplacement gratuit.
            </p>
            <p>
              Erstein, au sud de Strasbourg, connaît une expansion résidentielle rapide. Les lotissements neufs côtoient le centre historique alsacien avec ses maisons à colombages. Les fenêtres courent du PVC moderne au bois traditionnel, avec des mécanismes de toutes époques. Nous connaissons bien cette commune et intervenons chez vous.
            </p>
            <p>
              Notre atelier de Strasbourg est à proximité immédiate d'Erstein. Nous réparons les mécanismes modernes des nouveaux quartiers et les ferrures anciennes du centre-ville. C'est plus rapide, plus écologique et bien plus économique que le remplacement total. Déplacement et devis gratuits, pièce comprise.
            </p>
        </div>
      </div>
    </section>
  );
}